<div
  class="wrap"
  [class.success]="
    (deliveryItem | getDeliveryForDateStatus) === deliveryStatuses.CONFIRMED ||
    (deliveryItem | getDeliveryForDateStatus) === deliveryStatuses.DELIVERED
  "
  [class.warning]="
    (deliveryItem | getDeliveryForDateStatus) === deliveryStatuses.PENDING ||
    (deliveryItem | getDeliveryForDateStatus) === deliveryStatuses.REFUNDED
  "
  [class.error]="
    (deliveryItem | getDeliveryForDateStatus) === deliveryStatuses.ERROR
  "
>
  <div class="left">
    <span class="label">{{
      "@components.deliveryForDateStatus." +
        (deliveryItem | getDeliveryForDateStatus) +
        ".label" | translate
    }}</span>
    <span class="value">{{
      "@components.deliveryForDateStatus." +
        (deliveryItem | getDeliveryForDateStatus) +
        ".value"
        | translate
          : {
              date: deliveryItem.deliveryDate | date : "dd/MM/y"
            }
    }}</span>
  </div>
  <div class="right">
    <div
      class="confirmation-button"
      *ngIf="
        (deliveryItem | getDeliveryForDateStatus) === deliveryStatuses.DELIVERED
      "
    >
      <span class="label">
        {{
          "@components.deliveryForDateStatus.confirmationCta" | translate
        }}</span
      >
      <div class="arrow">
        <app-svg-icon
          class="icon"
          name="forward"
          [color]="'color-secondary-3'"
        ></app-svg-icon>
      </div>
    </div>
  </div>
</div>
